import { capitalizeFirstLetter } from "./TitleWord";

export const getItemNames = (name: string, translations: any, lang: string) => {
  let itemName = name;
  if (name && name?.split(" ")?.length > 1) {
    itemName = name?.split(" ")?.join("_");
  }
  return translations?.[lang]?.[itemName] || capitalizeFirstLetter(name);
};
